import React, { useState } from 'react';
import './SupportBot.css';

const SupportBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('menu'); // menu, faq, contact

  const faqs = [
    {
      question: 'What is Flash USDT?',
      answer: 'Flash USDT is a temporary USDT that can be used for trading and transfers. It has a validity of 15-30 days and can be transferred to unlimited wallets.'
    },
    {
      question: 'How long does delivery take?',
      answer: 'Your Flash USDT will be delivered within 5 to 10 minutes after payment verification.'
    },
    {
      question: 'What is the minimum order?',
      answer: 'The minimum order is 500 Flash USDT, which equals 10 USDT. The conversion rate is 1 USDT = 50 Flash USDT.'
    },
    {
      question: 'How long is Flash USDT valid?',
      answer: 'Flash USDT is valid for 15 to 30 days from the date of delivery.'
    },
    {
      question: 'Can I transfer Flash USDT to multiple wallets?',
      answer: 'Yes! You can transfer Flash USDT to unlimited wallets without any restrictions.'
    },
    {
      question: 'Which networks are supported?',
      answer: 'We support USDT TRC20, USDT ERC20, USDT BEP20, and Polygon networks.'
    },
    {
      question: 'How do I track my order?',
      answer: 'After placing your order, you will receive an Order ID. You can contact support with this ID to track your order status.'
    }
  ];

  const toggleBot = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setActiveTab('menu');
    }
  };

  const renderMenu = () => (
    <div className="bot-menu">
      <div className="bot-header">
        <div className="bot-avatar">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#00d4ff"/>
            <circle cx="8.5" cy="10.5" r="1.5" fill="#00d4ff"/>
            <circle cx="15.5" cy="10.5" r="1.5" fill="#00d4ff"/>
            <path d="M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" fill="#00d4ff"/>
          </svg>
        </div>
        <div className="bot-info">
          <h3>Support Bot</h3>
          <p className="bot-status"><span className="status-dot"></span> Online</p>
        </div>
      </div>

      <div className="bot-options">
        <button className="bot-option" onClick={() => setActiveTab('faq')}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#00d4ff" strokeWidth="2"/>
            <path d="M12 16v.01M12 13a2 2 0 002-2c0-1.1-.9-2-2-2s-2 .9-2 2" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <div>
            <strong>FAQs</strong>
            <p>Common questions</p>
          </div>
        </button>

        <button className="bot-option" onClick={() => setActiveTab('contact')}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <div>
            <strong>Contact Support</strong>
            <p>Email & Telegram</p>
          </div>
        </button>

        <a 
          href="https://t.me/codersaurav" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bot-option"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" fill="#00d4ff"/>
          </svg>
          <div>
            <strong>Talk to Seller</strong>
            <p>Direct Telegram chat</p>
          </div>
        </a>
      </div>
    </div>
  );

  const renderFAQ = () => (
    <div className="bot-faq">
      <div className="bot-header">
        <button className="back-btn" onClick={() => setActiveTab('menu')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M12 19l-7-7 7-7" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <h3>Frequently Asked Questions</h3>
      </div>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <details key={index} className="faq-item">
            <summary>{faq.question}</summary>
            <p>{faq.answer}</p>
          </details>
        ))}
      </div>
    </div>
  );

  const renderContact = () => (
    <div className="bot-contact">
      <div className="bot-header">
        <button className="back-btn" onClick={() => setActiveTab('menu')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M12 19l-7-7 7-7" stroke="#00d4ff" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <h3>Contact Support</h3>
      </div>

      <div className="contact-options">
        <div className="contact-card">
          <div className="contact-icon telegram">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" fill="#00d4ff"/>
            </svg>
          </div>
          <h4>Telegram Support Bot</h4>
          <a 
            href="https://t.me/flashsellersupportbot" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact-link telegram-link"
          >
            @flashsellersupportbot
          </a>
          <p className="contact-time">Instant automated support</p>
        </div>

        <div className="contact-card">
          <div className="contact-icon whatsapp">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" fill="#25D366"/>
            </svg>
          </div>
          <h4>WhatsApp Support</h4>
          <a 
            href="https://wa.me/919920015661" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact-link whatsapp-link"
          >
            +91 9920015661
          </a>
          <p className="contact-time">Available 24/7</p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={`support-bot ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="bot-content">
            {activeTab === 'menu' && renderMenu()}
            {activeTab === 'faq' && renderFAQ()}
            {activeTab === 'contact' && renderContact()}
          </div>
        )}
      </div>

      <button className="bot-toggle" onClick={toggleBot}>
        {isOpen ? (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        ) : (
          <svg width="40" height="40" viewBox="0 0 64 64" fill="none" className="robot-icon">
            {/* Robot Head */}
            <rect x="16" y="20" width="32" height="28" rx="4" fill="white" stroke="white" strokeWidth="2"/>
            
            {/* Antenna */}
            <line x1="32" y1="20" x2="32" y2="14" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="32" cy="12" r="2" fill="white">
              <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite"/>
            </circle>
            
            {/* Eyes */}
            <circle cx="26" cy="30" r="3" fill="#0a0e27">
              <animate attributeName="r" values="3;3.5;3" dur="2s" repeatCount="indefinite"/>
            </circle>
            <circle cx="38" cy="30" r="3" fill="#0a0e27">
              <animate attributeName="r" values="3;3.5;3" dur="2s" repeatCount="indefinite"/>
            </circle>
            
            {/* Smile */}
            <path d="M 24 38 Q 32 42 40 38" stroke="#0a0e27" strokeWidth="2" strokeLinecap="round" fill="none">
              <animate attributeName="d" 
                values="M 24 38 Q 32 42 40 38;M 24 38 Q 32 44 40 38;M 24 38 Q 32 42 40 38" 
                dur="3s" 
                repeatCount="indefinite"/>
            </path>
            
            {/* Arms */}
            <rect x="10" y="28" width="6" height="12" rx="2" fill="white">
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 13 34;-15 13 34;0 13 34"
                dur="2s"
                repeatCount="indefinite"/>
            </rect>
            <rect x="48" y="28" width="6" height="12" rx="2" fill="white">
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 51 34;15 51 34;0 51 34"
                dur="2s"
                repeatCount="indefinite"/>
            </rect>
            
            {/* Body Details */}
            <circle cx="32" cy="40" r="1.5" fill="#0a0e27" opacity="0.6"/>
            <line x1="28" y1="44" x2="36" y2="44" stroke="#0a0e27" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
          </svg>
        )}
      </button>
    </>
  );
};

export default SupportBot;
